import { render } from "./PantryCameraPage.vue?vue&type=template&id=1e717909&ts=true"
import script from "./PantryCameraPage.vue?vue&type=script&lang=ts"
export * from "./PantryCameraPage.vue?vue&type=script&lang=ts"

import "./PantryCameraPage.vue?vue&type=style&index=0&id=1e717909&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__